export const etiquetteQuizData = {
  "arrival": [
    {
      "question": "클래식 공연장에 도착해야 하는 권장 시간은 공연 시작 몇 분 전인가요?",
      "options": ["5분 전", "10분 전", "20분 전", "1시간 전"],
      "answer": 2,
      "explanation": "공연 시작 20분 전까지 도착하여 티켓을 발권하고 좌석을 확인한 후 입장하는 것이 좋습니다."
    },
    {
      "question": "클래식 공연에 지각했을 경우 올바른 입장 방법은 무엇인가요?",
      "options": ["공연 중이라도 바로 입장", "인터미션(휴식 시간)에 입장", "1막이 끝나면 언제든 입장", "입장이 완전히 불가능"],
      "answer": 1,
      "explanation": "부득이하게 지각할 경우에는 공연장 안내에 따라 인터미션에 입장할 수 있습니다."
    }
  ],
  "phone": [
    {
      "question": "클래식 공연 중 휴대전화는 어떻게 해야 하나요?",
      "options": ["진동 모드로 설정", "전원 끄기 또는 무음 설정", "일반 모드 유지", "카메라 앱 준비"],
      "answer": 1,
      "explanation": "클래식 공연에서는 휴대전화 전원을 끄거나 무음으로 설정하는 것이 기본 예절입니다."
    },
    {
      "question": "클래식 공연장에서 작은 소리도 크게 들리는 이유로 가장 적절한 것은 무엇인가요?",
      "options": ["마이크가 설치되어 있기 때문", "공연장 구조 특성상 소리가 증폭되기 때문", "관객이 너무 조용하기 때문", "음향 기사가 볼륨을 높이기 때문"],
      "answer": 1,
      "explanation": "공연장 특성상 작은 소리도 크게 들릴 수 있어 연주와 관람에 방해가 됩니다."
    }
  ],
  "dress": [
    {
      "question": "현재 클래식 공연장의 복장 예절에 대한 올바른 설명은 무엇인가요?",
      "options": ["반드시 정장을 입어야 한다", "편안한 복장도 가능하나 단정한 옷차림 권장", "청바지와 운동화는 절대 금지", "드레스코드가 엄격하게 적용된다"],
      "answer": 1,
      "explanation": "현재는 편안한 복장으로도 충분히 공연을 관람할 수 있지만, 단정하고 깔끔한 복장을 권장합니다."
    },
    {
      "question": "클래식 공연 복장에서 특히 피해야 할 것은 무엇인가요?",
      "options": ["어두운 색 옷", "지나치게 눈에 띄는 의상", "편안한 신발", "캐주얼한 복장"],
      "answer": 1,
      "explanation": "공연에 대한 존중의 의미로 지나치게 눈에 띄는 의상보다는 단정하고 깔끔한 복장을 권장합니다."
    }
  ],
  "photo": [
    {
      "question": "클래식 공연 중 사진 및 동영상 촬영에 대한 올바른 설명은 무엇인가요?",
      "options": ["자유롭게 촬영 가능", "사전 허가를 받은 관계자만 촬영 가능", "스마트폰으로는 항상 촬영 가능", "플래시 없이는 촬영 가능"],
      "answer": 1,
      "explanation": "공연 중에는 사전에 허가를 받은 관계자만 촬영할 수 있습니다."
    },
    {
      "question": "일부 공연에서 관객 촬영이 허용되는 시간은 언제인가요?",
      "options": ["공연 시작 전", "악장 사이 휴식 시간", "커튼콜(인사) 시간", "항상 금지"],
      "answer": 2,
      "explanation": "일부 공연에서는 연주자가 인사하는 커튼콜 시간에 한해 촬영이 허용되기도 합니다."
    }
  ],
  "applause": [
    {
      "question": "클래식 음악 공연에서 박수를 치는 올바른 타이밍은 언제인가요?",
      "options": ["각 악장이 끝날 때마다", "지휘자가 지휘봉을 내리거나 연주가 완전히 끝난 뒤", "음악이 잠시 멈출 때마다", "마음에 들 때마다"],
      "answer": 1,
      "explanation": "작품에 익숙하지 않다면 지휘자가 지휘봉을 내리거나 연주가 완전히 끝난 뒤 박수를 치는 것이 좋습니다."
    },
    {
      "question": "악장과 악장 사이에 박수를 치면 안 되는 이유로 가장 적절한 것은 무엇인가요?",
      "options": ["공연장 규정이기 때문", "연주자의 집중을 방해할 수 있기 때문", "소리가 너무 크기 때문", "전통적으로 금지된 행동이기 때문"],
      "answer": 1,
      "explanation": "악장 사이에 박수를 치면 다른 관객들에게 혼란을 줄 수 있고 연주자의 집중을 방해할 수도 있습니다."
    }
  ],
  "cough": [
    {
      "question": "공연 중 기침이 나올 것 같을 때 가장 올바른 대처 방법은 무엇인가요?",
      "options": ["크게 기침한다", "참고 억지로 견딘다", "피아니시모 구간을 피해 포르테 구간에 기침하거나 잠시 로비로 나간다", "바로 퇴장한다"],
      "answer": 2,
      "explanation": "피아니시모 구간을 피해 포르테 구간에 기침을 하거나, 심하다면 잠시 로비로 나가는 것이 배려입니다."
    },
    {
      "question": "공연 중 기침을 할 때 주변 방해를 줄이기 위한 방법으로 올바른 것은 무엇인가요?",
      "options": ["음악이 가장 조용한 구간에 기침한다", "손수건이나 소매로 입을 가리고 기침한다", "최대한 크게 한 번만 기침한다", "옆 사람에게 도움을 요청한다"],
      "answer": 1,
      "explanation": "손수건이나 소매로 입을 가리고, 음악이 강한 구간에 기침하면 방해를 최소화할 수 있습니다."
    }
  ],
  "program": [
    {
      "question": "공연 프로그램 노트를 미리 읽어두면 좋은 이유로 가장 적절한 것은 무엇인가요?",
      "options": ["공연 시간을 단축할 수 있기 때문", "어디서 박수를 쳐야 할지 알 수 있기 때문", "무료 음료를 받을 수 있기 때문", "좌석을 업그레이드할 수 있기 때문"],
      "answer": 1,
      "explanation": "프로그램 노트를 미리 읽으면 작품의 구성을 파악해 어디서 박수를 쳐야 할지 자연스럽게 알 수 있습니다."
    },
    {
      "question": "공연 프로그램 노트는 언제 확인하는 것이 권장되나요?",
      "options": ["공연이 끝난 후", "공연 중간 휴식 시간에", "공연장 로비에서 좌석 착석 전에", "집에서 미리 인터넷으로"],
      "answer": 2,
      "explanation": "프로그램 노트 확인은 공연장 로비에서 좌석 착석 전에 미리 해두시길 권장합니다."
    }
  ],
  "children": [
    {
      "question": "어린이와 함께 클래식 공연을 처음 관람할 때 권장되는 방법은 무엇인가요?",
      "options": ["일반 클래식 공연에 바로 데려간다", "패밀리 콘서트나 교육 프로그램부터 시작한다", "어린이 입장이 금지된다", "공연 내내 이어폰을 착용시킨다"],
      "answer": 1,
      "explanation": "클래식 공연은 긴 집중 시간이 필요하므로 어린이가 참여할 수 있는 패밀리 콘서트나 교육 프로그램부터 시작하는 것을 추천합니다."
    },
    {
      "question": "어린이 동반 시 아이가 소란을 피울 경우를 대비해 좋은 좌석 선택 방법은 무엇인가요?",
      "options": ["가장 앞줄 좌석 선택", "무대 중앙에 가까운 좌석 선택", "출구와 가까운 좌석 선택", "2층 좌석 선택"],
      "answer": 2,
      "explanation": "아이가 소란을 피울 경우를 대비해 출구와 가까운 좌석을 선택하는 것이 좋은 방법입니다."
    }
  ],
  "encore": [
    {
      "question": "앙코르 연주 중 관객이 해야 할 행동으로 올바른 것은 무엇인가요?",
      "options": ["조용히 퇴장한다", "연주자들이 무대를 완전히 떠날 때까지 앉아서 박수를 친다", "핸드폰으로 촬영을 시작한다", "음식을 먹으며 휴식을 취한다"],
      "answer": 1,
      "explanation": "앙코르 중에는 연주자들이 무대를 완전히 떠날 때까지 앉아서 계속 박수를 쳐야 합니다."
    },
    {
      "question": "클래식 공연장에서 퇴장하기 가장 적절한 시점은 언제인가요?",
      "options": ["마지막 곡이 끝나자마자", "앙코르가 시작될 때", "객석 조명이 켜질 때까지 기다린 후", "지휘자가 인사할 때"],
      "answer": 2,
      "explanation": "객석 조명이 켜질 때까지 기다렸다가 퇴장하는 것이 예의 바른 행동입니다."
    }
  ]
};
